import { render, staticRenderFns } from "./ResendDocs.vue?vue&type=template&id=c788831e&scoped=true&"
import script from "./ResendDocs.vue?vue&type=script&lang=js&"
export * from "./ResendDocs.vue?vue&type=script&lang=js&"
import style0 from "./ResendDocs.vue?vue&type=style&index=0&id=c788831e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c788831e",
  null
  
)

export default component.exports